import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getPaymentStatus (callback, param) {
    HTTP.get(param.token + '/payment').then(response => {
      callback(response.data)
    }).catch(e => {
      console.log(e)
    })
  },
  getOmisePublicKey (callback, param) {
    HTTP.get(param.token + '/payment/omise/public_key').then(response => {
      callback(response.data)
    }).catch(e => {
      console.log(e)
      callback(response.data)
    })
  },
  getPaypalCreatePaymentUrl (param) {
    return HttpFunctions.getApiBaseUrl() + param.token + '/paypal/create_payment'
  },
  getPaypalExecutePaymentUrl (param) {
    return HttpFunctions.getApiBaseUrl() + param.token + '/paypal/execute_payment'
  },
  getTransferLabel (callback, param) {
    HTTP.get(param.token + '/payment/transfer').then(response => {
      callback(response.data)
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/payment/index.js